/** GLB upload limit — must match platform-server PublicFileDB multer limits. */
export const MODEL_UPLOAD_MAX_SIZE_MB = 50;

export const MODEL_UPLOAD_MAX_BYTES = MODEL_UPLOAD_MAX_SIZE_MB * 1024 * 1024;
